import { render, staticRenderFns } from "./Perfis.vue?vue&type=template&id=1188bd88&scoped=true&"
import script from "./perfis.js?vue&type=script&lang=js&"
export * from "./perfis.js?vue&type=script&lang=js&"
import style0 from "./Perfis.vue?vue&type=style&index=0&id=1188bd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1188bd88",
  null
  
)

export default component.exports